export default class ConfigItemType {
  static get String () {
    return 'string'
  }

  static get Boolean () {
    return 'boolean'
  }
}
